import { IconExclamationCircle } from '@tabler/icons-react'
import React from 'react'

interface FormErrorProps {
    message?: string;
}

const FormError: React.FC<FormErrorProps> = ({ message }) => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height: '100%' }}>
            <div className='text-center text-danger'>
                <IconExclamationCircle size={72} />
                <p className='mt-3'>{message || 'An error occurred'}</p>
            </div>
        </div>
    )
}

export default FormError